import { Grid, Typography, Button, Box } from '@mui/material';
import { lazy } from 'react';
import { deleteCookie } from '../service/service';
import { useTheme } from "@mui/material/styles";

const Footer = lazy(() => import('../../src/components/LandingPage/ModuleLandingFooter'));

export default function SessionLogout() {
    const theme= useTheme();
    const colors = theme.palette;

    const idleout = () => {
            deleteCookie('id_token');
            window.location.href = "/";
        };

    return (
        <Box bgcolor="backgroundLight.primary">
            
            <Grid container justifyContent="center" alignItems="center" style={{ height: '80vh' }}>
                <Grid item xs={10} sm={8} md={6} lg={4} textAlign="center">
                    <Typography variant="h5" color={colors.textLight.secondary} gutterBottom>
                        Your session is expired.
                    </Typography>
                    <Typography variant="body1" color={colors.textLight.secondary} gutterBottom>
                        For security reasons, you have been automatically logged out due to 30 mins of inactivity.
                    </Typography>
                    <Button variant="contained" color="primary" onClick={idleout} sx={{ mt: 2 }}>
                        Go Back to Login
                    </Button>
                </Grid>
            </Grid>

            <Footer />
        </Box>
    );
}
